import {
  Chip,
  Avatar,
  Grid,
  styled,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "../../../Components/MDBox";
import MDButton from "../../../Components/MDButton";
import MDTypography from "../../../Components/MDTypography";
import { FieldRange } from "../../../Types/Api/DTO/FieldRangeDto";
import DetailChip from "../components/Chips/DetailChip";
import AddIcon from "@mui/icons-material/Add";
import AddCondition from "../components/modals/AddCondition";
import { ConditionalFieldDto } from "../../../Types/Api/DTO/ConditionalField";
import { ConditionKindEnum } from "../../../Types/Enums/ConditionKindEnum";
import { t } from "i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import { conditionsParamsAction } from "../../../Context/redux/actions";
import { ErrorToaast } from "../../../utils/toast/Toast";
const CustomDivider = styled("div")(({ theme }) => ({
  border: `1px grey solid`,
}));
function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number
) {
  return { name, calories, fat, carbs, protein };
}

export default function ThirdStep(props: {
  disabled: boolean;
  status: boolean;
  handleBack: any;
  handleNext: any;
}) {
  const [addModalOpen, setAddModalOpen] = useState<boolean>(false);
  let conditionsParams: ConditionalFieldDto[] = useSelector(
    (state: any) => state.conditionsParams
  );
  const dispatch = useDispatch();

  let symboledParams: FieldRange[] = useSelector(
    (state: any) => state.symboledParams
  );
  const hanldeNext = () => {
    if (conditionsParams.length < 1) {
      return ErrorToaast("حداقل نیازمند به یک شرط میباشد.");
    }
    props.handleNext();
  };
  const handleDeleteCondition = (id: string) => {
    dispatch(
      conditionsParamsAction(conditionsParams.filter((p) => p.uuid !== id))
    );
  };
  return (
    <MDBox px={2}>
      <MDBox>
        <MDBox bgColor={"#f0f2f5"} borderRadius={5} p={"10px 5px"} mb={5}>
          <MDTypography fontSize={14}>
            پارامتر های منتخب شده همراه با نماد آن در لیست زیر آمده است پارامتر
            های بدون نماد با @ مشخص شده اند . همچنین در جدول زیر شرط گذاری
            پارامتر های با نماد انجام شود
          </MDTypography>
        </MDBox>
        <MDBox bgColor={"ghostwhite"} py={1} px={1} my={2} borderRadius={5}>
          {symboledParams
            .sort((a, b) =>
              a.Symbole === b.Symbole ? 0 : a.Symbole > b.Symbole ? -1 : 1
            )
            .map((r) => {
              return (
                <DetailChip
                  label={r.Field.name}
                  symbole={r.Symbole}
                  key={r.Field.key}
                />
              );
            })}
        </MDBox>
        <Grid item container flexDirection={"column"}>
          <Grid item sx={{ width: "100%" }}>
            <MDBox py={1}>
              <Grid
                container
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Grid item>
                  <MDTypography fontSize={14}>شرط های موجود</MDTypography>
                </Grid>
                <Grid item>
                  <MDButton
                    variant="outlined"
                    color="secondary"
                    onClick={() => setAddModalOpen(true)}
                  >
                    افزودن
                    <AddIcon />
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
            <CustomDivider />
            <TableContainer sx={{ mt: 2, width: "100%" }}>
              <Table size="small">
                <TableHead sx={{ background: "#f0f2f5" }}>
                  <TableRow>
                    <TableCell>نام پارامتر</TableCell>
                    <TableCell align="right">نماد</TableCell>
                    <TableCell align="right">نوع شرط</TableCell>
                    <TableCell align="right">مقدار کمینه</TableCell>
                    <TableCell align="right">مقدار بیشینه </TableCell>
                    <TableCell align="right">مقدار برابری </TableCell>
                    <TableCell align="right">مقدار نماد </TableCell>
                    <TableCell align="right">عملیات</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {conditionsParams.length > 0 &&
                    conditionsParams.map((row) => (
                      <TableRow
                        key={row.uuid}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="right">{row.Field.name}</TableCell>
                        <TableCell align="right">{row.ParamName}</TableCell>
                        <TableCell align="right">
                          {t(ConditionKindEnum[row.GhabzRowsKindEnum])}
                        </TableCell>
                        <TableCell align="right">
                          {row.ParamMin.toString()}
                        </TableCell>
                        <TableCell align="right">
                          {row.ParamMax.toString()}
                        </TableCell>
                        <TableCell align="right">
                          {row.ParamEqual.toString()}
                        </TableCell>
                        <TableCell align="right">
                          {row.ParamAmount.toString()}
                        </TableCell>
                        <TableCell align="right">
                          <DeleteIcon
                            color="error"
                            fontSize="medium"
                            sx={{ cursor: "pointer" }}
                            onClick={() => handleDeleteCondition(row.uuid)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  {conditionsParams.length === 0 && (
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell colSpan={8} align="right">
                        هیچ شرطی موجود نمی باشد
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </MDBox>

      <MDBox sx={{ display: "flex", flexDirection: "row", py: 2 }}>
        <MDButton
          color="primary"
          variant={"outlined"}
          disabled={props.disabled}
          onClick={props.handleBack}
          sx={{ mr: 1 }}
        >
          مرحله قبل
        </MDButton>
        <MDBox sx={{ flex: "1 1 auto" }} />

        <MDButton onClick={hanldeNext} variant={"outlined"} color="info">
          {props.status ? "اتمام" : "مرحله بعد"}
        </MDButton>
      </MDBox>
      <AddCondition
        addModalOpen={addModalOpen}
        setAddModalOpen={setAddModalOpen}
      />
    </MDBox>
  );
}
